var React = require('react');

function InfoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.00033 0.666656C4.39795 0.666656 0.666992 4.39762 0.666992 8.99999C0.666992 11.2101 1.54497 13.3297 3.10777 14.8925C4.67057 16.4553 6.79019 17.3333 9.00033 17.3333C11.2105 17.3333 13.3301 16.4553 14.8929 14.8925C16.4557 13.3297 17.3337 11.2101 17.3337 8.99999C17.3337 6.78985 16.4557 4.67024 14.8929 3.10743C13.3301 1.54463 11.2105 0.666656 9.00033 0.666656ZM2.33366 8.99999C2.33366 12.675 5.32533 15.6667 9.00033 15.6667C12.6753 15.6667 15.667 12.675 15.667 8.99999C15.667 5.32499 12.6753 2.33332 9.00033 2.33332C5.32533 2.33332 2.33366 5.32499 2.33366 8.99999ZM9.83366 4.83332V6.49999H8.16699V4.83332H9.83366ZM9.83366 8.16666V13.1667H8.16699V8.16666H9.83366Z","fill":"#FE5100"}));
}

InfoInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = InfoInline;

InfoInline.default = InfoInline;
